export * from './ChessBoard';
export { default } from './ChessBoard';
